import { Routes } from '@angular/router';
import { PreloadAllModules, RouterModule } from '@angular/router';

import { authGuard } from './services/auth.guard';



export const routes: Routes = [

  {
    path: 'home',
    // loadChildren: () => import('./pages/tabs/tabs.routes').then((m) => m.routes),
    loadComponent: () => import('./pages/home/home.page').then( m => m.HomePage),
    canActivate: [authGuard],
  },
  {
    path: 'report',
    // loadChildren: () => import('./pages/tabs/tabs.routes').then((m) => m.routes),
    loadComponent: () => import('./pages/reports/reports.page').then( m => m.ReportsPage),
    canActivate: [authGuard],
  },
  {
    path: 'settings',
    // loadChildren: () => import('./pages/tabs/tabs.routes').then((m) => m.routes),
    loadComponent: () => import('./pages/settings/settings.page').then( m => m.SettingsPage),
    canActivate: [authGuard],
  },
  // {
  //   path: 'dashboard',
  //   // loadChildren: () => import('./pages/tabs/tabs.routes').then((m) => m.routes),
  //   loadComponent: () => import('./pages/dashboard/dashboard.page').then( m => m.DashboardPage),
  //   canActivate: [authGuard],
  // },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: 'login', 
    loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage)
  },
  {
    path: '**',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  
  // {
  //   path: 'dashboard',
  //   loadComponent: () => import('./pages/dashboard/dashboard.page').then( m => m.DashboardPage)
  // },
];


